const pushToDataLayer = window.BAO.Utils.pushToDataLayer

class ProductShopTheLook extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['open', 'close', 'modal', 'items']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.els.open.element, 'click', this.showModal.bind(this))
    this.listeners.add(this.els.close.element, 'click', this.closeModal.bind(this))
    this.listeners.add(window, 'quick-add:open', this.closeModal.bind(this))
  }

  async showModal () {
    const modal = this.els.modal.element

    modal.showModal()

    await this.createItems().then((itemsFragment) => {
      const itemsContainer = this.els.items.element

      itemsContainer.innerHTML = ''
      itemsContainer.appendChild(itemsFragment)
      // Bind click listener for tracking on items. Remove any previous handler first
      if (this._shopTheLookItemHandler) {
        itemsContainer.removeEventListener('click', this._shopTheLookItemHandler)
      }

      this._shopTheLookItemHandler = (e) => {
        const productCard = e.target.closest && e.target.closest('product-card')
        if (!productCard) return

        const productId = productCard?.dataset?.productId || null
        const productTitle = productCard?.querySelector('.card__heading')?.textContent?.trim() || null

        const parameters = {
          item_product_id: productId,
          item_title: productTitle,
        }

        pushToDataLayer('pdp_shop_the_look_product_click', parameters)
      }

      itemsContainer.addEventListener('click', this._shopTheLookItemHandler)
    })

    setTimeout(() => {
      modal.classList.add(this.activeClass)
    }, 500)

    pushToDataLayer('pdp_shop_the_look_open')
  }

  closeModal () {
    const modal = this.els.modal.element;
    modal.classList.remove(this.activeClass);

    try {
      const itemsContainer = this.els.items && this.els.items.element
      if (this._shopTheLookItemHandler && itemsContainer) {
        itemsContainer.removeEventListener('click', this._shopTheLookItemHandler)
        this._shopTheLookItemHandler = null
      }
    } catch (err) {
      console.error('Error removing shop the look item click handler:', err)
    }

    modal.addEventListener('transitionend', () => {
      modal.close();
    }, { once: true });
  }

  async createItems () {
    const fragment = document.createDocumentFragment()
    const productHandles = this.getAttribute('data-product-handles').split(',').map(handle => handle.trim())

    const listItemPromises = productHandles.map(async (handle) => {
      const productCardFetch = await this.getProductCardHTML(handle)
      const productCardElement = productCardFetch.querySelector('product-card')

      const listItem = document.createElement('li')
      listItem.classList.add('prd-ShopTheLook_Dialog_Item')
      listItem.appendChild(productCardElement)

      return listItem
    })

    const listItems = await Promise.all(listItemPromises)

    listItems.forEach(listItem => {
      fragment.appendChild(listItem)
    })

    return fragment
  }

  async getProductCardHTML (productHandle) {
    try {
      const response = await fetch(`${Shopify.routes.root}products/${productHandle}?section_id=card-product-model`)

      if (!response.ok) {
        throw new Error(`Fetch request failed with status ${response.status}`)
      }

      const text = await response.text()
      const parser = new DOMParser()
      const doc = parser.parseFromString(text, 'text/html')

      return doc
    } catch (err) {
      console.error(err)
    }
  }

  get activeClass () {
    return 'prd-ShopTheLook_Dialog-open'
  }
}

customElements.define('product-shop-the-look', ProductShopTheLook)
